/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Team_Manager_Role_Viewer_DescInputs */



/**
* | output |
* | --- |
* | "Opens and reviews projects" |
*
* @param {Team_Manager_Role_Viewer_DescInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const team_manager_role_viewer_desc = /** @type {((inputs?: Team_Manager_Role_Viewer_DescInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Team_Manager_Role_Viewer_DescInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Ouvre et consulte des projets")
	if (locale === "de") return /** @type {LocalizedString} */ ("Öffnet und prüft Projekte")
	if (locale === "it") return /** @type {LocalizedString} */ ("Apre e rivede progetti")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Открывает и просматривает проекты")
	if (locale === "es") return /** @type {LocalizedString} */ ("Abre y revisa proyectos")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("打开和查看项目")
	if (locale === "ja") return /** @type {LocalizedString} */ ("プロジェクトを開いて確認")
	if (locale === "hi") return /** @type {LocalizedString} */ ("प्रोजेक्ट खोलता और समीक्षा करता है")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Abre e revê projetos")
	return /** @type {LocalizedString} */ ("Opens and reviews projects")
});